import { ChipsideComponent } from "../chipside-component";

export class Checkbox extends ChipsideComponent {
	static observedAttributes = ["checked", "value"];
	#Mappers = {};

	constructor() {
		super();

		this.identifier = this.getAttribute("identifier") ?? crypto.randomUUID().slice(0, 8);
		this.type = this.getAttribute("type") ?? "";
		this.label = this.getAttribute("label");
		this.checked = this.hasAttribute("checked");
		this.helperText = this.getAttribute("helper-text") ?? "";
		this.value = this.getAttribute("value") ?? "true";

		this.#Mappers = {
			name: this.getAttribute("name")
		};

		if (this.closest("form") && !this.#Mappers.name) { this.#Mappers.name = this.id ?? this.identifier; }
	}

	parsedCallback() {
		this.classList.add("checkbox__wrapper");

		const checkbox = document.createElementWithContents("input", null, {
			id: this.identifier,
			className: `input-field${this.type === "switch" ? " switch" : ""}`.trim(),
			type: "checkbox",
			checked: this.checked,
			value: this.value
		});

		checkbox.addEventListener("change", () => this.checked = checkbox.checked);

		Object.keys(this.#Mappers).filter(x => this.#Mappers[x])
			.forEach(key => checkbox.setAttribute(key, this.#Mappers[key] === true ? "" : this.#Mappers[key]));

		if (this.helperText) {
			this.prepend(document.createElementWithContents("div", this.helperText, {
				className: "input-field__helper-text"
			}));
		}

		if (this.label) { this.prepend(document.createElementWithContents("label", this.label, { htmlFor: this.identifier })); }

		this.prepend(checkbox);
	}

	attributeChanged(name, _, newValue) {
		if (name === "checked") {
			this.querySelector("input").checked = this.IsAttributeValueTrue(newValue);
		}
	}
}